/* eslint-disable object-curly-newline */
/* eslint-disable arrow-parens */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import AceEditor from 'react-ace';

import 'ace-builds/src-noconflict/mode-javascript';
import 'ace-builds/src-noconflict/theme-dracula';

import api from '~/services/api';
import history from '~/services/history';
import { Container, Row, Header, ButtonTest } from './styles';

export default function Challenges() {
  const [challenges, setChallenges] = useState([]);
  const [feedback, setFeedback] = useState('');

  useEffect(() => {
    async function getData() {
      const { data } = await api.get('/educator/scorecards');

      setChallenges(data);
    }

    getData();
  }, [challenges]);

  const handleInputChange = (index) => (e) => {
    const updateFeedback = [...challenges];
    updateFeedback[index] = setFeedback(e.target.value);
  };

  async function handleSubmit(e, id, status) {
    e.preventDefault();

    await api.put(`/educator/scorecards/${id}`, { status, feedback });

    return toast.success('Correçāo enviada com sucesso.');
  }

  return (
    <>
      <Header>
        <ButtonTest
          type="submit"
          onClick={() => history.push('/educatorChallenge')}
          selected
        >
          <h2>Desafios</h2>
        </ButtonTest>
        <ButtonTest type="submit" onClick={() => history.push('/educatorJobs')}>
          <h2>Vagas</h2>
        </ButtonTest>
        <ButtonTest
          type="submit"
          onClick={() => history.push('/educatorTutoria')}
        >
          <h2>Tutoria</h2>
        </ButtonTest>
        <ButtonTest
          type="submit"
          onClick={() => history.push('/educatorUsers')}
        >
          <h2>Usuários</h2>
        </ButtonTest>
      </Header>
      <Container>
        <h1>Desafios pendentes para correçāo: ({challenges.length})</h1>

        {challenges.map((challenge, index) => {
          if (challenge.challenge.type === 'code') {
            return (
              <Row key={challenge.id}>
                <p>ID da Resposta: {challenge.id}</p>
                <p>
                  Aluno: {challenge.user.first_name} {challenge.user.last_name}
                </p>
                <p>ID do Desafio: {challenge.challenge.id}</p>
                <p>Título: {challenge.challenge.title}</p>
                <p>Pergunta: {challenge.challenge.question}</p>
                <p>Resposta:</p>

                <AceEditor
                  placeholder="Placeholder Text"
                  mode={`${challenge.challenge.language}`}
                  theme="dracula"
                  name="blah2"
                  // onLoad={onLoad}
                  // onChange={onChange}
                  fontSize={14}
                  showPrintMargin
                  showGutter
                  highlightActiveLine
                  value={
                    challenge.code_answer === null
                      ? 'Nāo foi possível carregar o script.'
                      : challenge.code_answer
                  }
                  width="80%"
                  height="300px"
                />
                <p>Gabarito:</p>
                <AceEditor
                  placeholder="Placeholder Text"
                  mode={`${challenge.challenge.language}`}
                  theme="dracula"
                  name="blah2"
                  // onLoad={onLoad}
                  // onChange={onChange}
                  fontSize={14}
                  showPrintMargin
                  showGutter
                  highlightActiveLine
                  value={
                    challenge.challenge.answer === null
                      ? 'Nāo foi possível carregar o script ou nāo possui gabarito.'
                      : challenge.challenge.answer
                  }
                  width="80%"
                  height="300px"
                />
                <form>
                  <textarea
                    type="text"
                    placeholder="Digite o feedback da resposta"
                    value={feedback}
                    onChange={handleInputChange(index)}
                  />
                  <button
                    type="submit"
                    className="correct"
                    onClick={(e, status = 'correct') =>
                      handleSubmit(e, challenge.id, status)
                    }
                  >
                    CORRETO
                  </button>
                  <button
                    type="submit"
                    className="wrong"
                    onClick={(e, status = 'wrong') =>
                      handleSubmit(e, challenge.id, status)
                    }
                  >
                    ERRADO
                  </button>
                </form>
              </Row>
            );
          }
          return (
            <Row key={challenge.id}>
              <p>ID da Resposta: {challenge.id}</p>
              <p>
                Aluno: {challenge.user.first_name} {challenge.user.last_name}
              </p>
              <p>ID do Desafio: {challenge.challenge.id}</p>
              <p>Título: {challenge.challenge.title}</p>
              <p>Pergunta: {challenge.challenge.question}</p>
              <p>Resposta: {challenge.link_answer}</p>
              <p>Gabarito: {challenge.challenge.answer}</p>
              <form>
                <textarea
                  type="text"
                  placeholder="Digite o feedback da resposta"
                  value={feedback}
                  onChange={handleInputChange(index)}
                />
                <button
                  type="submit"
                  className="correct"
                  onClick={(e, status = 'correct') =>
                    handleSubmit(e, challenge.id, status)
                  }
                >
                  CORRETO
                </button>
                <button
                  type="submit"
                  className="wrong"
                  onClick={(e, status = 'wrong') =>
                    handleSubmit(e, challenge.id, status)
                  }
                >
                  ERRADO
                </button>
              </form>
            </Row>
          );
        })}
      </Container>
    </>
  );
}
